import React from "react";

import classNames from "classnames";
import { Field } from "formik";
import { FormattedMessage } from "gatsby-plugin-react-intl";
import PropTypes from "prop-types";
import Form from "react-bootstrap/Form";

import { ReactComponent as IconError18 } from "../../../icons/icon/18/a-icon-error-18.svg";

const FormField = ({
  errors,
  id,
  label,
  maxLength = Number.MAX_SAFE_INTEGER,
  meta,
  onBlur,
  onChange,
  onKeyPress = () => {},
  placeholder = undefined,
  touched,
  type,
  validateField = () => {},
  values,
}) => (
  <Field name={id} validate={validateField}>
    {() => (
      <>
        <Form.Group
          controlId={id}
          className={classNames(
            { required: meta.requiredFields.includes(id) },
          )}
        >
          <Form.Control
            type={type}
            placeholder={placeholder}
            value={values?.[id]}
            maxLength={maxLength}
            onBlur={onBlur}
            onKeyPress={onKeyPress}
            onChange={onChange}
            isInvalid={(errors[id] && touched[id])}
          />
          <Form.Label>
            {label}
          </Form.Label>
          <Form.Text
            className={classNames({ "invalid-feedback": (errors[id] && touched[id]) })}
          >
            {errors[id] && touched[id]
              ? <div><IconError18 />{errors[id]}</div>
              : <>{!meta.requiredFields.includes(id) && <FormattedMessage id="form.optional" />}</>}
          </Form.Text>
        </Form.Group>
      </>
    )}
  </Field>
);

FormField.propTypes = {
  errors: PropTypes.oneOfType([PropTypes.object]).isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  maxLength: PropTypes.number,
  meta: PropTypes.oneOfType([PropTypes.object]).isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func,
  placeholder: PropTypes.string,
  touched: PropTypes.oneOfType([PropTypes.object]).isRequired,
  type: PropTypes.string.isRequired,
  validateField: PropTypes.func,
  values: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
};

export default FormField;
